addDefaultCSS("https://bannerbeaver.herokuapp.com/ppp_assets/style.css");
const shop_name="bleu-rod-beattie.myshopify.com";
var appearanceData, featureData, elem_ppb = document.getElementById("product-pages-banners"), url = window.location.href, script_name = document.currentScript.src, handle = (handle = url.split("/").pop()).split("?").length && (handle = handle.split("?").shift());
function addDefaultCSS(e) {
    var t = document.getElementsByTagName("head")[0]
      , n = document.createElement("link");
    n.rel = "stylesheet",
    n.type = "text/css",
    n.href = e,
    t.appendChild(n)
}
ifSnippetNotInstalled2();
var correctNode = null;
function ifSnippetNotInstalled2() {
    if (null == elem_ppb) {
        var e = document.querySelectorAll("button[type=submit]");
        for (i = 0; i < e.length; i++)
            if (e[i].name.includes("add") || "add-to-cart" == e[i].getAttribute("data-action") || null != e[i].getAttribute("data-product-atc")) {
                correctNode = i;
                break
            }
        cartnode = div = document.createElement("div"),
        div.setAttribute("id", "product-pages-banners"),
        e[correctNode].parentNode.insertBefore(div, e[correctNode]),
        elem_ppb = document.getElementById("product-pages-banners")
    }
}
function appendDesignDivToAppDiv(e) {
    if (css = `margin-top:${e.banner_margin_top}px;margin-bottom:${e.banner_margin_bottom}px`,
    cssbanner = `background-color:${e.bg_color};padding:${e.banner_padding}px 12px;border-radius:${e.border_radius}px;`,
    elem_ppb.setAttribute("style", css),
    (createDesignDiv = document.createElement("div")).className = "pretty-banner-div",
    createDesignDiv.setAttribute("style", cssbanner),
    "" != e.link && createDesignDiv.addEventListener("click", function() {
        location.href = e.link
    }, !1),
    "" != e.link && (cssbanner += "cursor:pointer;"),
    createDesignDiv.setAttribute("style", cssbanner),
    1 == e.has_shadow && (cssbanner += "box-shadow:0px 3px 8px rgba(0,0,0,0.24);",
    createDesignDiv.setAttribute("style", cssbanner)),
    1 == e.has_gradient) {
        rgbaColor = hexToRgbA(e.bg_color),
        newcolorToRgba = hexToRgbA(newcolor = hexToComplimentary(e.bg_color)),
        newRgba = rgbaColor.replace("1)", "0.65)");
        var t = "background-image:linear-gradient(" + rgbaColor + ", " + newcolorToRgba + ");";
        cssbanner = cssbanner.split(/;(.+)/)[1],
        cssbanner += t,
        createDesignDiv.setAttribute("style", cssbanner)
    }
    1 == e.number_of_icons && (cssbanner += "justify-content:start",
    createDesignDiv.setAttribute("style", cssbanner)),
    "no_icon" == e.icon_type && (cssbanner += "justify-content:center",
    createDesignDiv.setAttribute("style", cssbanner)),
    null != elem_ppb ? elem_ppb.appendChild(createDesignDiv) : console.log("PPP not installed")
}
function hexToRgbA(e) {
    var t;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(e))
        return 3 == (t = e.substring(1).split("")).length && (t = [t[0], t[0], t[1], t[1], t[2], t[2]]),
        "rgba(" + [(t = "0x" + t.join("")) >> 16 & 255, t >> 8 & 255, 255 & t].join(",") + ",1)";
    throw Error("Bad Hex")
}
function hexToComplimentary(e) {
    var t = "rgb(" + (e = e.replace("#", "")).match(RegExp("(.{" + e.length / 3 + "})", "g")).map(function(t) {
        return parseInt(e.length % 2 ? t + t : t, 16)
    }).join(",") + ")"
      , n = (t = t.replace(/[^\d,]/g, "").split(","))[0]
      , r = t[1]
      , a = t[2];
    n /= 255;
    var l, s, o = Math.max(n, r /= 255, a /= 255), p = Math.min(n, r, a), c = (o + p) / 2;
    if (o == p)
        l = s = 0;
    else {
        var d = o - p;
        s = c > .5 ? d / (2 - o - p) : d / (o + p),
        o == n && r >= a ? l = 1.0472 * (r - a) / d : o == n && r < a ? l = 1.0472 * (r - a) / d + 6.2832 : o == r ? l = 1.0472 * (a - n) / d + 2.0944 : o == a && (l = 1.0472 * (n - r) / d + 4.1888)
    }
    if (l = l / 6.2832 * 360 + 0,
    (l += 30) > 360 && (l -= 360),
    l /= 360,
    0 === s)
        n = r = a = c;
    else {
        var b = function(e, t, n) {
            return n < 0 && (n += 1),
            n > 1 && (n -= 1),
            n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e
        }
          , g = c < .5 ? c * (1 + s) : c + s - c * s
          , u = 2 * c - g;
        n = b(u, g, l + 1 / 3),
        r = b(u, g, l),
        a = b(u, g, l - 1 / 3)
    }
    return n = Math.round(255 * n),
    r = Math.round(255 * r),
    "#" + (16777216 | (t = (a = Math.round(255 * a)) | r << 8 | n << 16)).toString(16).substring(1)
}
fetch(`https://bannerbeaver.herokuapp.com/front_end/index?shop=${shop_name}&handle=${handle}`).then(async e=>{
    try {
        (await e.json()).forEach(function(e, t) {
            "no_icon" == e.icon_type ? (appendDesignDivToAppDiv(e),
            nthChild = "nth-child(" + (t + 1) + ")",
            document.querySelector(".pretty-banner-div:" + nthChild).insertAdjacentHTML("afterbegin", "<div class=pretty-banner-text-div><p class=pretty-banner-title style=text-align:center;color:" + e.title_color + ";font-size:" + e.title_size + "px;font-weight:" + e.font_weight + ">" + e.title + "</p><div class=pretty-banner-subtitle style=text-align:center;color:" + e.subtitle_color + ";font-size:" + e.subtitle_size + "px>" + e.subtitle + "</div></div>")) : 2 == e.number_of_icons ? (appendDesignDivToAppDiv(e),
            nthChild = "nth-child(" + (t + 1) + ")",
            document.querySelector(".pretty-banner-div:" + nthChild).insertAdjacentHTML("afterbegin", "<div class=pretty-banner-img-div style=width:" + e.icon_size + "px;height:" + e.icon_size + "px;><img class=pretty-banner-img src=" + e.main_image + "></div><div class=pretty-banner-text-div><p class=pretty-banner-title style=color:" + e.title_color + ";font-size:" + e.title_size + "px;font-weight:" + e.font_weight + ">" + e.title + "</p><div class=pretty-banner-subtitle style=color:" + e.subtitle_color + ";font-size:" + e.subtitle_size + "px>" + e.subtitle + "</div></div><div class=pretty-banner-img-div style=width:" + e.icon_size + "px;height:" + e.icon_size + "px;><img class=pretty-banner-img src=" + e.main_image + "></div>")) : (appendDesignDivToAppDiv(e),
            nthChild = "nth-child(" + (t + 1) + ")",
            document.querySelector(".pretty-banner-div:" + nthChild).insertAdjacentHTML("afterbegin", "<div class=pretty-banner-img-div style=width:" + e.icon_size + "px;height:" + e.icon_size + "px;><img class=pretty-banner-img src=" + e.main_image + "></div><div class=pretty-banner-text-div><p class=pretty-banner-title style=text-align:left;color:" + e.title_color + ";font-size:" + e.title_size + "px;font-weight:" + e.font_weight + ">" + e.title + "</p><div class=pretty-banner-subtitle style=text-align:left;color:" + e.subtitle_color + ";font-size:" + e.subtitle_size + "px>" + e.subtitle + "</div></div>"))
        })
    } catch (t) {
        console.log(t)
    }
}
);
